module.exports = __webpack_public_path__ + "img/player_cover.373e0739.png";